import { useMutation } from '@apollo/client'
import { message, Modal } from 'antd'
import { APPEAL_AI_ARTWORK } from '~/graphqls/gqls'
import {
  AiArtworkAppealScene,
  appealAiArtWork,
  appealAiArtWorkVariables,
  RiskControlStatus,
} from '~/graphqls/types'
import { graphQLErrorMessage } from '~/utils'

export const useAppeal = ({ ids }: { ids: number[] }) => {
  const [appealAction] = useMutation<appealAiArtWork, appealAiArtWorkVariables>(
    APPEAL_AI_ARTWORK
  )

  /** 提交申诉 */
  const handleSubmit = (scene: AiArtworkAppealScene) => {
    appealAction({
      variables: {
        param: {
          aiArtworkIds: ids,
          appealReason: '',
          scene,
        },
      },
    })
      .then(res => {
        if (res?.data?.pictureMutation?.status) {
          message.destroy()
          message.success('提交成功，请耐心等待～')
        }
      })
      .catch(err => {
        message.destroy()
        message.error(graphQLErrorMessage(err) || '未知错误')
      })
  }

  const handleAppeal = (scene: AiArtworkAppealScene) => {
    Modal.confirm({
      className: 'hookModal dark',
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      content: <div>图片涉嫌违规</div>,
      okText: '确认申诉',
      cancelText: '好的',
      onOk: close => {
        handleSubmit(scene)
        close()
      },
      onCancel: close => {
        close()
      },
    })
  }

  const verifyAppealStatus = ({
    status,
    scene,
  }: {
    status: RiskControlStatus | null | undefined
    scene: AiArtworkAppealScene
  }) => {
    if (status === RiskControlStatus.NEED_APPEAL) {
      handleAppeal(scene)
      return true
    }
    if (status === RiskControlStatus.APPEAL_REFUSE) {
      message.destroy()
      message.error('图片涉嫌违规')
      return true
    }
    if (status === RiskControlStatus.BE_REPORTED) {
      message.destroy()
      message.error('该作品被用户举报，经审核存在违规风险')
      return true
    }
    if (status === RiskControlStatus.APPEAL_PROCESSING) {
      message.destroy()
      message.warning('正在申诉中，请耐心等待～')
      return true
    }
    return false
  }

  return { handleAppeal, verifyAppealStatus }
}
